/**
 * @generated SignedSource<<509cf13edf6c40f2530ec5ad898f6e66>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MapElementTooltip_tooltip",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "content",
      "storageKey": null
    }
  ],
  "type": "MapElementTooltip",
  "abstractKey": null
};

node.hash = "f10d57977cc4e80bc1fb7e5164c5defc";

module.exports = node;
